<script setup lang="ts">
import type { PartnerPortalContactSessionFragmentFragment } from '@/graphql/pp/generated/graphql';

interface PartnerMenuProps {
  partner: PartnerPortalContactSessionFragmentFragment,
  partners: PartnerPortalContactSessionFragmentFragment[],
  setPartner:(value: PartnerPortalContactSessionFragmentFragment) => void,
}
defineProps<PartnerMenuProps>();
</script>

<template>
  <MenuDropdown
    class="z-20"
    items-class="right-0 mt-2 origin-top-right w-full"
  >
    <template #title>
      <div class="flex justify-between space-x-2 items-center">
        <div class="">
          <SchoolLogo
            :name="partner.partner.school.school_name"
            :logo="partner.partner.school.logo_url"
            class="h-12"
          />
        </div>
        <div class="h-5 w-5 text-(--color-sidebar-menu-text)">
          <UiFaIcon
            :icon="['fal', 'chevron-down']"
            class="h-5 w-5"
            aria-hidden="true"
          />
        </div>
      </div>
    </template>
    <template #items>
      <MenuDropdownItem
        v-for="item in partners"
        :key="item.id"
        :title="item.partner.school.school_name"
        @click="setPartner(item)"
      />
    </template>
  </MenuDropdown>
</template>
